export const SET_PRICE_MODELS = 'SET_PRICE_MODELS';
export const SET_TRIM_COUNTS = 'SET_TRIM_COUNTS';
export const SET_PRICE_RANGE = 'SET_PRICE_RANGE';
export const SET_MODEL_KEYS = 'SET_MODEL_KEYS';
export const ADD_ITEM = 'ADD_ITEM';
export const REMOVE_ITEM = 'REMOVE_ITEM';
export const RESET = 'RESET';
export const SET_ONLY_FUTURE_VEHICLES = 'SET_ONLY_FUTURE_VEHICLES';
export const SET_ONLY_NSX = 'SET_ONLY_NSX';
